import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface LanguageState {
  current: "ta" | "en" | "de";
  available: string[];
}

const initialState: LanguageState = {
  current: "ta",
  available: ["ta", "en", "de"],
};

export const languageSlice = createSlice({
  name: "language",
  initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<"ta" | "en" | "de">) => {
      state.current = action.payload;
    },
    addLanguage: (state, action: PayloadAction<string>) => {
      if (!state.available.includes(action.payload)) {
        state.available.push(action.payload);
      }
    },
  },
});

export const { setLanguage, addLanguage } = languageSlice.actions;
export default languageSlice.reducer;
